import type { BaseType } from 'antd/es/typography/Base';
import { useCallback } from 'react';
import type { TypographyType } from '../../typography';

export const useGetType = () =>
  useCallback((type?: TypographyType): BaseType | undefined => {
    switch (type) {
      case 'danger':
      case 'secondary':
      case 'success':
      case undefined:
      case 'warning':
        return type;
      case 'light':
      case 'primary':
      case 'title':
        return undefined;
    }
  }, []);
